module.exports = __webpack_public_path__ + "media/images/app/register/google-icon-white-26019f2fba541c02f381a6bfaf4ba3e8.svg";